import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Neighborhoodreview
const GQLAddCityReview = gql`
  mutation addCityReview(
    $cityname: String
    $UserID: String
    $author: String
    $createDate: String
    $helpfulCount: Int
    $heading: String
    $description: String
    $communityRating: Float
    $publicSpacesRating: Float
    $curbAppealRating: Float
    $jobsRating: Float
    $keywords: String
    $greatfor: String
    $editor_rate: Int
  ) {
    createcityreview(
      cityname: $cityname
      UserID: $UserID
      author: $author
      createDate: $createDate
      helpfulCount: $helpfulCount
      heading: $heading
      description: $description
      communityRating: $communityRating
      publicSpacesRating: $publicSpacesRating
      curbAppealRating: $curbAppealRating
      jobsRating: $jobsRating
      keywords: $keywords
      greatfor: $greatfor
      editor_rate: $editor_rate
    ) {
      success
      message
    }
  }
`;

//Update Neighborhoodreview
const GQLUpdateNeighbourReview = gql`
  mutation updateNeighbourReview($id: String!, $helpfulCount: Int) {
    Updateneighborhoodreview(id: $id, helpfulCount: $helpfulCount) {
      success
      message
    }
  }
`;

//Delete Neighborhoodreview
const GQLDeleteCityReview = gql`
  mutation deleteCityReview($id: String!) {
    deletecityreview(id: $id) {
      success
      message
    }
  }
`;

const GQLHelpCityReview = gql`
  mutation helpcityReview(
    $reviewId: String
    $cityId: String
    $userId: String
    $helpStatus: Int
    $helpedDate: String
    $updatedDate: String
  ) {
    helpcityReview(
      reviewId: $reviewId
      cityId: $cityId
      userId: $userId
      helpStatus: $helpStatus
      helpedDate: $helpedDate
      updatedDate: $updatedDate
    ) {
      success
      message
    }
  }
`;

//Get All User
const QUERY_getAllcityreviewList = gql`
  query getcityreview(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
    $auth_userId: String
  ) {
    getcityreview(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
      auth_userId: $auth_userId
    ) {
      id
      cityname
      UserID
      author
      createDate
      helpfulCount
      heading
      description
      communityRating
      publicSpacesRating
      curbAppealRating
      jobsRating
      helpStatus
      keywords
      userDetails {
        id
        type
        firstName
        lastName
        email
        password
        aboutMe
        numberNeighborhoodsReviewed
        likes
        questionsAnswered
        points
        realEstateFirm
        license
        phone
        aboutMe
        isagent
        ishomebuyer
        ishomeseller
        isneighbor
        istopagent
        userimage
        displayname
      }
      helpedUserId
      greatfor
      editor_rate
      cityimages {
        imageurl
      }
    }
  }
`;

//Get All City score
const QUERY_getAllcityscore = gql`
  query getcityscore(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getcityscore(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      totalnpi
      npisore
      personalscore
      valuescore
      schoolscore
      crimescore
      walkscore
      comscore
      crubscore
      otherscore
      medianpricescore
      primaryscore
      middlescore
      highscore
      dom
      appreciation
      amenitiesscore
    }
  }
`;

const QUERY_editorrate = gql`
  mutation cityeditorrate($editor_rate: Int, $cityName: String, $id: String) {
    cityeditorrate(editor_rate: $editor_rate, cityName: $cityName, id: $id) {
      success
      message
    }
  }
`;

const QUERY_editcityreview = gql`
  mutation editcityreview(
    $description: String
    $neighborhoodId: String
    $reviewId: String
    $keywords: String
    $publicSpacesRating: Float
    $curbAppealRating: Float
  ) {
    editcityreview(
      description: $description
      neighborhoodId: $neighborhoodId
      reviewId: $reviewId
      keywords: $keywords
      publicSpacesRating: $publicSpacesRating
      curbAppealRating: $curbAppealRating
    ) {
      success
      message
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addcityreview(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddCityReview,
        variables: {
          cityname: adddata.cityname,
          UserID: adddata.UserID,
          author: adddata.author,
          createDate: adddata.createDate,
          helpfulCount: adddata.helpfulCount,
          heading: adddata.heading,
          description: adddata.description,
          communityRating: adddata.communityRating,
          publicSpacesRating: adddata.publicSpacesRating,
          curbAppealRating: adddata.curbAppealRating,
          jobsRating: adddata.jobsRating,
          keywords: adddata.keywords,
          greatfor: adddata.greatfor,
          editor_rate: adddata.editor_rate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updateneighborhoodreview(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateNeighbourReview,

        variables: {
          id: updatedata.id,
          helpfulCount: updatedata.helpfulCount,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Delete Function

async function deletecityreview(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLDeleteCityReview,
        variables: {
          id: deletedataId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function helpcityreview(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLHelpCityReview,
        variables: {
          reviewId: adddata.reviewId,
          cityId: adddata.cityId,
          userId: adddata.userId,
          helpStatus: adddata.helpStatus,
          helpedDate: adddata.helpedDate,
          updatedDate: adddata.updatedDate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function editorrate(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: QUERY_editorrate,
        variables: {
          editor_rate: adddata.editor_rate,
          cityName: adddata.cityName,
          id: adddata.id,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Get list by own query
async function getAllcityreview(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllcityreviewList,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
          auth_userId: getdata.auth_userId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Get top score
async function getcityscore(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllcityscore,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function editcityreview(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: QUERY_editcityreview,
        variables: {
          description: adddata.description,
          neighborhoodId: adddata.neighborhoodId,
          reviewId: adddata.reviewId,
          keywords: adddata.keywords,
          publicSpacesRating: adddata.publicSpacesRating,
          curbAppealRating: adddata.curbAppealRating,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export {
  addcityreview,
  updateneighborhoodreview,
  deletecityreview,
  getAllcityreview,
  helpcityreview,
  editorrate,
  getcityscore,
  editcityreview,
};
